<template>
  <!-- 围栏管理 -->
  <div class="page">
    <!-- 搜索区域 -->
    <div class="search" v-permission="['fenceManage:search']">
      <el-form ref="form" :model="searchParams" label-width="auto" class="from">
        <el-form-item :label="$t('pages.operate.text71')">
          <el-input
            v-model="searchParams.geoName"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.operate.text2')">
          <el-select
            v-model="searchParams.status"
            :placeholder="$t('public.text5')"
            clearable
          >
            <el-option :label="$t('pages.operate.text73')" :value="0">
            </el-option>
            <el-option :label="$t('pages.operate.text74')" :value="1">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="searchSubmit">
        <DiluButton type="search" @click="search"></DiluButton>
        <DiluButton type="reset" @click="reset"></DiluButton>
      </div>
    </div>

    <!-- 按钮区域 -->
    <div class="operation">
      <DiluButton
        type="add"
        @click="add"
        v-permission="['fenceManage:add']"
      ></DiluButton>
    </div>

    <div class="map-contents">
      <div class="map-input">
        <input type="text" v-model="addrValue" id="map-input" />
        <div @click="searchGoogle()" v-if="isGoogle">
          <i class="el-icon-search"></i>
        </div>
        <div @click="getLocation()" v-else><i class="el-icon-search"></i></div>
      </div>
      <div id="fence-map"></div>
    </div>

    <!-- 表格 -->
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
      :pageSize="searchParams.pageSize"
      @currentChange="currentChange"
      :total="total"
    >
      <el-table-column prop="bikeCategoryName" label="#" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="geoName"
        :label="$t('pages.operate.text71')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="status"
        :label="$t('pages.operate.text2')"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.status == 0
              ? $t("pages.operate.text73")
              : $t("pages.operate.text74")
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="speedLimit"
        :label="$t('pages.operate.text75')"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.speedLimit }}km/h</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        :label="$t('public.text4')"
        align="center"
        width="160px"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                {{ $t("public.text4")
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :command="{ type: 'see', data: scope.row }"
                  v-permission="['fenceManage:see']"
                  >{{ $t("button.look") }}</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{ type: 'edit', data: scope.row }"
                  v-permission="['fenceManage:edit']"
                  >{{ $t("button.edit") }}</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{ type: 'vehicles', data: scope.row }"
                  v-permission="['fenceManage:manage']"
                  >{{ $t("menu.manageVehicles") }}</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{ type: 'remove', data: scope.row }"
                  v-permission="['fenceManage:remove']"
                  >{{ $t("button.delete") }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
      </el-table-column>
    </DiluTable>

    <AddFence
      @mapdialogVisibleCloe="mapdialogVisibleCloe"
      @geoList="geoList"
      :mapDialogVisible="mapDialogVisible"
      :pageType="pageType"
      :currentFence="currentFence"
    />
  </div>
</template>


<script>
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import AddFence from "./module/addFence.vue";
import { mapState } from "vuex";
import remoteLoad from "@/assets/js/remoteLoad.js";
export default {
  data() {
    return {
      searchParams: {
        geoName: "", //电子围栏名称
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        // limit: 10, //单页条数
        // page: 1, //页码
        status: null, //状态（0：有效，1：无效）
      },

      tableConfig: {
        isTree: false,
        isPage: true,
      },
      total: 0,
      tableData: [],

      mapDialogVisible: false,
      pageType: 0,
      currentFence: {},

      //地图
      isGoogle: false,
      center: { lat: 51.51108087472238, lng: -0.12420020719467573 },
      zoom: 2,
      map: null,
      addrValue: null,
      bermudaTriangle: null,
      infowindow: null,
      infowindowmarker: null,
      isSerch: false, //是否在查询
    };
  },
  components: {
    DiluTable,
    AddFence,
    DiluButton,
  },
  computed: {
    ...mapState(["regionList", "currentRegion", "platformData"]),
  },
  mounted() {
    // this.initMap();
    this.geoList();
  },
  methods: {
    //操作
    handleCommand(e) {
      if (e.type == "see") {
        this.see(e.data);
      }
      if (e.type == "edit") {
        this.edit(e.data);
      }
      if (e.type == "vehicles") {
        this.vehicles(e.data);
      }
      if (e.type == "remove") {
        this.remove(e.data);
      }
    },
    //管理车辆
    vehicles(e) {
      this.$router.push({
        path: "/operate/fence/manageVehicles",
        query: {
          id: e.id,
        },
      });
      // console.log(e);
    },
    //搜索
    search() {
      this.isSerch = true; //是否在查询
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.geoList();
    },
    //初始化地图
    initMap(e) {
      let arr = this.regionList;
      if (arr[this.currentRegion].id != "cn") {
        if (window.google) {
          this.initGoogleMap(e);
          // 未载入谷歌地图API，则先载入API再初始化
        } else {
          // 载入谷歌地图和UI组件
          Promise.all([
            remoteLoad(
              "https://maps.googleapis.com/maps/api/js?key=AIzaSyByfqxMers4lp-sXvkU4P8dX4i6yQ3RZ84&libraries=visualization,places,geometry&language=en-us&region=EG"
            ),
          ]).then(() => {
            this.initGoogleMap(e);
          });
        }
        this.isGoogle = true;
      } else {
        if (window.AMap && window.AMapUI) {
          this.initCnMap(e);
          // 未载入高德地图API，则先载入API再初始化
        } else {
          // 载入高德地图和UI组件
          Promise.all([
            remoteLoad(
              "https://webapi.amap.com/maps?v=1.4.15&key=77faf27c291ef4d7a20bfb8d5f74b0b4&plugin=AMap.Riding,AMap.PolyEditor"
            ),
          ]).then(() => {
            this.initCnMap(e);
          });
        }

        this.isGoogle = false;
      }
    },
    //初始化谷歌地图
    initGoogleMap(e) {
      // let that = this;
      this.map = new google.maps.Map(document.getElementById("fence-map"), {
        center: { lat: -34.397, lng: 150.644 },
        mapId: "1dac188ecae44d48",
        zoom: 8,
        mapTypeControl: false,
        disableDefaultUI: true,
      });
      this.see(e);
    },
    //设置谷歌地图点
    setGoogleMarker(e) {
      let that = this;
      if (that.marker) {
        that.marker.setMap(null);
      }
      that.marker = new google.maps.Marker({
        position: e,
        map: that.map,
      });
    },
    //谷歌地图搜索服务
    searchGoogle() {
      let that = this;
      const request = {
        query: that.addrValue,
        fields: ["name", "geometry"],
      };

      let service = new google.maps.places.PlacesService(that.map);
      service.findPlaceFromQuery(request, (results, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && results) {
          that.map.setCenter(results[0].geometry.location);
          that.setGoogleMarker({
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng(),
          });
        }
      });
    },

    //初始化高德地图
    initCnMap(e) {
      this.map = new AMap.Map("fence-map", {
        mapStyle: "amap://styles/398469a1eaea0a930c1cb33226ee3080", //设置地图的显示样式
        zoom: 5,
        resizeEnable: true,
      });
      this.see(e);
    },
    //高德地图设置点
    setMarker(e) {
      let that = this;
      if (that.marker) {
        that.marker.setMap(null);
        that.marker = null;
      }
      that.marker = new AMap.Marker({
        icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
        position: [e.lng, e.lat],
      });
      that.marker.setMap(that.map);
      that.map.setCenter([e.lng, e.lat]);
    },
    //高德搜索位置
    getLocation() {
      let that = this;
      AMap.service(["AMap.PlaceSearch"], function () {
        var placeSearch = new AMap.PlaceSearch();
        placeSearch.search(that.addrValue, function (status, result) {
          if (status == "complete" && result.info == "OK") {
            that.setMarker({
              lng: result.poiList.pois[0].location.lng,
              lat: result.poiList.pois[0].location.lat,
            });
            that.addrValue = "";
          } else {
            that.$message({
              message: that.$t("pages.operate.text96"),
              type: "warning",
            });
          }
        });
      });
    },
    //电子围栏列表
    geoList() {
      this.searchParams.belongCustomerId = this.platformData.id;
      this.request.geoList(this.searchParams).then((res) => {
        this.tableData = res.data;
        this.total = res.dataMaxCount;
        this.initMap(res.data[0]);
      });
    },
    //谷歌地图查看位置
    setGoogleMap(center, paths, fence) {
      let that = this;
      if (that.bermudaTriangle) {
        that.bermudaTriangle.setMap(null);
      }
      if (that.infowindow) {
        that.infowindow.setMap(null);
      }

      if (that.infowindowmarker) {
        that.infowindowmarker.setMap(null);
      }

      this.center = center;
      this.map.setZoom(16);
      this.map.setCenter(this.center);
      that.bermudaTriangle = new google.maps.Polygon({
        paths: paths,
        strokeColor: fence.status == 0 ? "#1890FF" : "#A7A7A7",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor:
          fence.status == 0
            ? "rgba(24, 144, 255, 0.2)"
            : "rgba(24, 144, 255, .07)",
        fillOpacity: 0.35,
      });

      const contentString = `
      <div class="dilu-map-fence">
        <div class="dilu-map-fence-top">
            <div class="dilu-map-fence-icon">
                <span></span><span></span><span></span><span></span>
            </div>
            <div class="dilu-map-fence-title">${fence.geoName}</div>
        </div>
        <div class="speed-limit">speed-limit</div>
        <div class="dilu-map-fence-bottom">
            <div>${fence.speedLimit}km/h</div>
            <div style="background-color:${
              fence.status == 0 ? "rgba(24, 144, 255, .07)" : "#F9F9F9"
            };color:${fence.status == 0 ? "#1890ff" : "#A7A7A7"}">${
        fence.status == 0 ? "effective" : "Invalid"
      }</div>
        </div>
    </div>`;
      that.infowindow = new google.maps.InfoWindow({
        content: contentString,
      });
      that.infowindowmarker = new google.maps.Marker({
        position: center,
        map: that.map,
        title: "",
      });

      that.infowindowmarker.addListener("click", () => {
        that.infowindow.open({
          anchor: that.infowindowmarker,
          map: that.map,
          shouldFocus: false,
        });
      });
      that.infowindow.open({
        anchor: that.infowindowmarker,
        map: that.map,
        shouldFocus: false,
      });

      that.bermudaTriangle.setMap(this.map);
    },
    //高德地图查位置
    setCnMap(center, paths, fence) {
      let that = this;

      if (this.infowindowmarker) {
        this.map.remove(that.infowindowmarker);
      }
      if (this.bermudaTriangle) {
        this.map.remove(that.bermudaTriangle);
      }
      if (this.infoWindow) {
        this.map.remove(that.infoWindow);
      }

      this.infowindowmarker = new AMap.Marker({
        position: center,
        icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
        map: that.map,
      });
      this.map.setZoomAndCenter(15, center);

      that.bermudaTriangle = new AMap.Polygon({
        path: paths,
        fillColor:
          fence.status == 0
            ? "rgba(24, 144, 255, 0.2)"
            : "rgba(24, 144, 255, .07)", // 多边形填充颜色
        borderWeight: 2, // 线条宽度，默认为 1
        strokeColor: fence.status == 0 ? "#1890FF" : "#A7A7A7", // 线条颜色
      });
      this.map.add(that.bermudaTriangle);
      const contentString = [];
      contentString.push(
        '<div class="dilu-map-fence"><div class="dilu-map-fence-top"><div class="dilu-map-fence-icon"><span></span><span></span><span></span><span></span></div><div class="dilu-map-fence-title">'
      );
      contentString.push(fence.geoName + "</div>");
      contentString.push(
        '</div><div class="speed-limit">speed-limit</div><div class="dilu-map-fence-bottom"><div>'
      );
      contentString.push(fence.speedLimit + "km/h</div>");
      contentString.push(
        '<div style="background-color:' + fence.status == 0
          ? "rgba(24, 144, 255, .07)"
          : "#F9F9F9" + ";color:" + fence.status == 0
          ? "#1890ff"
          : "#A7A7A7" + '">' + fence.status == 0
          ? "effective"
          : "Invalid" + "</div>"
      );
      contentString.push("</div></div>");
      this.infoWindow = new AMap.InfoWindow({
        offset: new AMap.Pixel(8, -30),
        content: contentString.join(""),
      });

      this.infoWindow.open(that.map, center);
    },
    //查看
    see(e) {
      console.log(e);
      let arr = this.regionList;
      if (arr[this.currentRegion].id != "cn") {
        let paths = JSON.parse(e.geoPoint).map((item) => {
          return new google.maps.LatLng(item);
        });
        this.setGoogleMap({ lat: e.centerLat, lng: e.centerLon }, paths, e);
      } else {
        let paths = JSON.parse(e.geoPoint).map((item) => {
          return new AMap.LngLat(item.lng, item.lat);
        });
        this.setCnMap(new AMap.LngLat(e.centerLon, e.centerLat), paths, e);
      }
    },
    //新增
    add() {
      this.pageType = 0;
      this.mapDialogVisible = true;
    },
    //关闭弹窗
    mapdialogVisibleCloe() {
      this.mapDialogVisible = false;
    },
    //删除围栏
    remove(e) {
      let that = this;
      this.$confirm(
        that.$t("pages.operate.text85"),
        that.$t("pages.operate.text81"),
        {
          confirmButtonText: that.$t("button.determine"),
          cancelButtonText: that.$t("button.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.request
            .geoDelFence({ id: e.id, belongCustomerId: this.platformData.id })
            .then(() => {
              this.$message.success(that.$t("pages.operate.text86"));
              this.searchParams.pageNum = 1;
              this.geoList();
            });
        })
        .catch(() => {});
    },
    // 重置
    reset() {
      this.isSerch = false; //是否在查询
      this.searchParams = {
        geoName: "", //电子围栏名称
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        status: null, //状态（0：有效，1：无效）
      };
      this.total = 0;
      this.geoList();
    },
    //翻页
    currentChange(e) {
      if (!this.isSerch) {
        this.searchParams = {
          geoName: "", //电子围栏名称
          pageNum: 1, //页码
          pageSize: 10, //每页条数
          status: null, //状态（0：有效，1：无效）
        };
      }
      this.searchParams.pageNum = e;
      this.geoList();
    },
    //修改
    edit(e) {
      this.pageType = 1;
      this.mapDialogVisible = true;
      this.currentFence = e;
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
}
.searchSubmit {
  float: right;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
/* #fence-map {
  width: 100%;
  height: 400px;
  margin-bottom: 20px;
  flex-shrink: 0;
} */
#fence-map {
  width: 100%;
  height: 350px;
  margin-bottom: 20px;
}
.map-contents {
  position: relative;
}
.map-input {
  width: 260px;
  height: 46px;
  background-color: #fff;
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 22;
  border-radius: 8px;
  box-shadow: 0 2px 6px 0 rgb(114 124 245 / 50%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 10px;
  box-sizing: border-box;
}
.map-input input {
  flex: 1;
  border: none;
  outline: none;
  background-color: transparent;
}
.map-input div {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
  height: 100%;
  border-left: 1px solid #dfdfdf;
  cursor: pointer;
}
.map-input div i {
  font-size: 24px;
}
</style>